import BoxContent from "../common/BoxContent";
import CurrentOrganization from "./CurrentOrganization";

const AdminBoxConent: React.FC<{
  title: string;
  hasAddNew?: boolean;
  isAddNewEnabled?: boolean;
  addNewTitle?: string;
  onAddNew?: any;
  beforeAddNewContent?: any;
  addNew2Title?: string;
  isAddNew2Enabled?: boolean;
  onAddNew2?: any;
  hasCount?: boolean;
  count?: number;
  countType?: string;
  hasCurrentOrganizationDropdown: boolean;
  children: any;
}> = ({
  title,
  hasAddNew = true,
  isAddNewEnabled = true,
  addNewTitle = "Add New",
  onAddNew,
  beforeAddNewContent,
  addNew2Title,
  isAddNew2Enabled = true,
  onAddNew2,
  hasCount = true,
  count,
  countType,
  hasCurrentOrganizationDropdown,
  children,
}) => {
  return (
    <BoxContent
      title={title}
      useFullWidth
      leftChildren={
        <div>
          <div
            className="d-flex justify-content-end align-items-center"
            style={{ visibility: hasAddNew ? "visible" : "hidden" }}
          >
            {beforeAddNewContent}
            <button
              className="btn btn-primary"
              style={{ marginTop: "5px", marginBottom: "10px" }}
              disabled={!isAddNewEnabled}
              onClick={() => onAddNew()}
            >
              {addNewTitle}
            </button>
            {addNew2Title && (
              <button
                className="btn btn-primary"
                style={{
                  marginTop: "5px",
                  marginBottom: "10px",
                  marginLeft: "10px",
                }}
                disabled={!isAddNew2Enabled}
                onClick={() => onAddNew2()}
              >
                {addNew2Title}
              </button>
            )}
          </div>
          {hasCount && (
            <div className="d-flex justify-content-end">
              <p>{`${count} ${countType}`}</p>
            </div>
          )}
        </div>
      }
    >
      {hasCurrentOrganizationDropdown && (
        <div
          className="d-flex align-items-center"
          style={{ marginTop: "-15px", marginBottom: "10px" }}
        >
          <div style={{ marginRight: "10px", fontWeight: "bold" }}>
            Organization
          </div>
          <CurrentOrganization />
        </div>
      )}
      {children}
    </BoxContent>
  );
};

export default AdminBoxConent;
